import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { INotification, NotificationsPage, NotificationsPagedData } from './notifications-model';

@Injectable()
export class NotificationsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'notificationlogs';

    /** POST */
    public getNotifications(page: NotificationsPage): Observable<SuccessResponse<NotificationsPagedData<INotification>> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<NotificationsPagedData<INotification>>>(
                NotificationsService.URL +
                NotificationsService.ENDPOINT +
                '/filters',
                page
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

}
